import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import "../../../style/custommillingHubdashboard.css";
import "../../../style/designer-milling-responsive.css";
import "../../../style/customresponsivefile.css";
import "../../../style/Cancelorder.css";   

import SearchBox from "../../../.../../Interfaces/SearchBoxProps";
import SortFilter from "../../CentralHub/Designer/SortFilter";
import { CompleteOrderRow, FileItem } from "../../CentralHub/Admin/Interfaces/CompleteOrderRow";
import { apiAxios } from "../../../utils/apiAxios";

const DesignerCompleteOrders: React.FC = () => {

  const [orders, setOrders] = useState<CompleteOrderRow[]>([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedOrder, setSelectedOrder] = useState<CompleteOrderRow | null>(null);
  const [showModal, setShowModal] = useState(false);

  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage] = useState(10);
  const EllipsisText = ({ text }: { text: string }) => (
    <span
      title={text}
      style={{
        display: "inline-block",
        maxWidth: "120px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {text}
    </span>
  );
  // 🔥 API CALL
  const fetchOrders = async (pageNumber = 1, search = "") => {
    try {
      setLoading(true);

      const res = await apiAxios.get("/Desginer/completed-orders", {
        params: {
          search,
          pageNumber,
          pageSize: perPage
        }
      });

      const json = res.data;
      if (json.isSuccess) {

        const apiData = json.dataOne.data;
        console.log("Completed Orders API Response:", apiData);
        const mapped: CompleteOrderRow[] = apiData.map((item: any) => ({
          orderId: item.orderID ?? "-",
          clinicName: item.clinicName ?? "-",
          phone: item.phone ?? "-",
          orderTypeName: item.orderTypeName ?? "-",
          orderDate: item.orderDate
            ? new Date(item.orderDate).toLocaleDateString("en-GB") + " " +
            new Date(item.orderDate).toLocaleTimeString()
            : "-",
          millingHub: item.millingHub ?? "-",
          designerName: item.designerName ?? "-",
          deliveryPartner: item.deliveryPartner ?? "-",
          deliveryDate: item.deliveryDate
            ? new Date(item.deliveryDate).toLocaleString()
            : "-",
          paymentType: item.paymentType ?? "-",
          status: item.status ?? "-",
        files: item.files ?? [],

deletedByName: item.deletedByName ?? item.DeletedByName ?? null,
deletedAt: item.deletedAt ?? item.DeletedAt ?? null,

fileUploadedDate:
  item.files?.length > 0
    ? new Date(item.files[0].createdDate).toLocaleString()
    : "N/A"
        }));

        setOrders(mapped);
        setTotalRows(json.dataOne.totalRecords);

      } else {
        toast.error("No data found");
      }

    } catch (error) {
      console.error(error);
      toast.error("Failed to load completed orders");
    } finally {
      setLoading(false);
    }
  };



  const constructFileUrl = (filePath: string): string => {
    if (!filePath) return "";

    let baseUrl = process.env.REACT_APP_API_BASE_URL || "";

    baseUrl = baseUrl.replace(/\/api$/, "");

    return `${baseUrl}${filePath}`;
  };

  const downloadFile = async (filePath: string, fileName?: string) => {
    const fullUrl = constructFileUrl(filePath);

    try {
      const token = sessionStorage.getItem("token");

      const { data, headers } = await apiAxios.get(fullUrl, {
        responseType: "blob",
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
        },
      });

      // 📄 Extract filename from header if not provided
      let finalName = fileName;
      const disposition = headers["content-disposition"];

      if (!finalName && disposition) {
        const match = disposition.match(/filename="?(.+?)"?$/);
        if (match) finalName = match[1];
      }

      finalName = finalName || "download";

      // 📦 Create blob with proper type
      // const blob = new Blob([data], {
      //   type: headers["content-type"],
      // });

      const contentType =
        typeof headers["content-type"] === "string"
          ? headers["content-type"]
          : undefined;

      const blob = new Blob([data], {
        type: contentType,
      });
      const url = window.URL.createObjectURL(blob);

      // ⬇️ Download
      const link = document.createElement("a");
      link.href = url;
      link.download = finalName;
      document.body.appendChild(link);
      link.click();

      // 🧹 Cleanup
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);

       toast.success(`Downloading file`);
    } catch (error) {
      console.error("Download failed:", error);

      // 🔁 Fallback (keep this — it's good UX)
      try {
        window.open(fullUrl, "_blank");
        toast.info("Opened in new tab");
      } catch {
        toast.error("Failed to download file");
      }
    }
  };


  useEffect(() => {
    fetchOrders(page, searchText);
  }, [page]);

  // 🔥 SEARCH (Debounce)
  useEffect(() => {
    const delay = setTimeout(() => {
      setPage(1);
      fetchOrders(1, searchText);
    }, 500);

    return () => clearTimeout(delay);
  }, [searchText]);

  // 🔥 TABLE COLUMNS
  const columns = [
    {
      name: "OrderID",
      selector: (row: CompleteOrderRow) => row.orderId,
      sortable: true
    },
    {
      name: "Order Type",
      selector: (row: CompleteOrderRow) => row.orderTypeName,
      sortable: true
    },

    {
      name: "Clinic / Phone",
      minWidth: "180px",
      cell: (row: CompleteOrderRow) => (
        <div>
          <div className="fw-semibold">{row.clinicName}</div>
          <div className="text-muted">{row.phone}</div>
        </div>
      )
    },

    {
  name: "Order Date",
  cell: (row: CompleteOrderRow) => (
    <EllipsisText text={row.orderDate} />
  )
},

    // {
    //   name: "Milling Hub",
    //   selector: (row: CompleteOrderRow) => row.millingHub
    // },

    // {
    //   name: "Payment",
    //   cell: (row: CompleteOrderRow) => (
    //     <span className="badge bg-success">
    //       {row.paymentType}
    //     </span>
    //   )
    // },

    {
      name: "Status",
      width: "240px",
      cell: (row: CompleteOrderRow) => (
        <span className="badge bg-success">
          {row.status}
        </span>
      )
    },

    {
      name: "View",

      cell: (row: CompleteOrderRow) => (
        <button
          className="action-btn edit"
          onClick={() => {
            setSelectedOrder(row);
            setShowModal(true);
          }}
        >
          <i className="bi bi-eye"></i>
        </button>
      ),
      width: "100px",
    }

  ];

  return (

    <div className="container-fluid mt-4">


      <h4 className="mb-4">Designer Completed</h4>



      <div className="premium-card mt-4">

        <div className="d-flex justify-content-between mb-3">

          <SearchBox
            value={searchText}
            onChange={setSearchText}
          />

          <SortFilter />

        </div>

        <DataTable
          columns={columns}
          data={orders}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangePage={(page) => setPage(page)}
          highlightOnHover
          striped
          responsive
          progressPending={loading}
          fixedHeader
          fixedHeaderScrollHeight="500px"
          className="admin-delivery-table"
        />

      </div>

      {/* 🔥 MODAL */}




      {showModal && selectedOrder && (
      <div className="modal fade show d-block modal-bg">
  <div className="modal-dialog" style={{ maxWidth: "660px", width: "100%" }}>
    <div className="modal-content">

              <div className="modal-header premium-modal-header">
                {/* <h6 className="mb-0">Order Details</h6> */}
                <h5 className="modal-title"> Order Details: {selectedOrder?.orderId || "--"}</h5>

                <button
                  className="custom-close-btn btn-close"
                  onClick={() => setShowModal(false)}
                >
                  <i className="bi bi-x customcross"></i>
                </button>
              </div>

              <div className="modal-body premium-modal-body pt-0">
                <ul className="list-unstyled order-details-list mb-0">

                  <li className="order-item d-flex justify-content-between align-items-center border-bottom py-2">
                    <span className="label">Designer</span>
                    <span className="value">{selectedOrder.designerName}</span>
                  </li>
                <li className="order-item d-flex justify-content-between align-items-start border-bottom py-2">
  
  {/* LEFT SIDE LABEL */}
  <span className="label">Download File</span>

  {/* RIGHT SIDE FILES */}
<div
  className="value d-flex flex-column align-items-end gap-2 file-scroll"
  style={{
    maxHeight: "120px",
    overflowY: "auto",
    paddingRight: "4px",
  }}
>
  {selectedOrder?.files?.length ? (
    selectedOrder.files.map((file: FileItem) => (
     <button
  key={file.fileID}
  className="btn btn-sm btn-link text-primary p-0 d-flex align-items-center gap-1"
  onClick={() => downloadFile(file.imagePath, file.fileName)}
  style={{ textDecoration: "none" }}
  title={file.fileName}
>
  <i className="bi bi-download"></i>

  <span
    style={{
      maxWidth: "200px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      display: "inline-block",
    }}
  >
    {file.fileName}
  </span>
</button>
    ))
) : selectedOrder?.deletedByName && selectedOrder?.deletedAt ? (
  <span className="text-danger text-end">
    Deleted by {selectedOrder.deletedByName} on{" "}
    {new Date(selectedOrder.deletedAt).toLocaleString("en-GB")}
  </span>
) : (
  <span className="text-muted">No File</span>
)}
</div>
</li>

                  <li className="order-item d-flex justify-content-between align-items-center border-bottom py-2">
                    <span className="label">Designer File Completed Date</span>
                    <span className="value">{selectedOrder.fileUploadedDate}</span>
                  </li>
                </ul>
              </div>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DesignerCompleteOrders;